import { z } from "zod";

export const registerSchema = z.object({
  companyName: z.string().min(2, "Il nome dell'azienda deve avere almeno 2 caratteri"),
  referentName: z.string().min(2, "Il nome del referente deve avere almeno 2 caratteri"),
  email: z.string().email("Inserisci un indirizzo email valido"),
  countryCode: z.string().min(1, "Seleziona il prefisso"),
  phone: z
    .string()
    .min(6, "Inserisci un numero di telefono valido")
    .regex(/^\d[\d\s\-]*\d$/, "Numero di telefono non valido"),
});

export type RegisterFormData = z.infer<typeof registerSchema>;

function splitName(fullName: string): { name: string; surname: string } {
  const trimmed = fullName.trim();
  const spaceIndex = trimmed.indexOf(" ");
  if (spaceIndex === -1) return { name: trimmed, surname: "" };
  return {
    name: trimmed.slice(0, spaceIndex),
    surname: trimmed.slice(spaceIndex + 1).trim(),
  };
}

export function toRegisterPayload(data: RegisterFormData) {
  const { name, surname } = splitName(data.referentName);
  const phone = `${data.countryCode.replace(/\s/g, "")}${data.phone.replace(/\D/g, "")}`;
  return { name, surname, phone, email: data.email, companyName: data.companyName };
}
